import { DocumentProps, PDFViewer } from '@react-pdf/renderer';
import React, { ReactElement } from 'react';

import styles from '../styles.module.scss';

export interface PdfViewerProps {
  children: ReactElement<DocumentProps>;
}

const PdfViewer = ({ children }: PdfViewerProps) => (
  <PDFViewer showToolbar height="100%" width="100%" className={styles.Letter}>
    {children}
  </PDFViewer>
);

export default PdfViewer;
